import {useEffect} from "react";
import {useDrawer} from "../../redux/Reducers/DrawerReducer";
import logo from "../../assets/img/logo.png"
import Icon from "../Icon/Icon";
import  "./sidebar.css"

export default function SidebarMobile({className, ...props}) {
    const {isDrawerOpen, actions} = useDrawer();

    useEffect(() => {
        if (isDrawerOpen) {
            document.body.classList.add("filter-class"); // Add
            let main = document.getElementById("root");
            main.scrollIntoView({behavior: "smooth"});


        } else {
            document.body.classList.remove("filter-class"); // Add

        }

    }, [isDrawerOpen])
    return (
        <div onClick={actions.closeDrawer} className={`${!isDrawerOpen ? "hidden" : ""} no-selection fixed  z-[1000] top-0 left-0  w-full h-full `}>

            <div onClick={(e) => e.stopPropagation()}
                 className={`  flex flex-col open-left-to-right-drawer-main  w-[250px]  h-full dark:bg-gray-800 bg-white shadow-xl rounded-r-xl`}>
                <div className={"flex mb-8 mt-[2rem] items-center justify-center px-4 "}>
                    <div className={"flex-1 flex justify-center items-center"}>
                        <img alt={"logo"} src={"/images/logo.svg"} className={"h-8"}/>
                    </div>
                    <div
                        onClick={actions.closeDrawer}
                        className={"w-8 text-center h-8 shadow-xl bg-gray-100 flex justify-center items-center cursor-pointer  rounded-full p-1"}>
                        <Icon name={"cross"} className={"text-gray-700 w-3"}/>
                    </div>
                </div>
                <div className={"overflow-y-auto"}>
                    {
                        props.children
                    }
                </div>


            </div>
        </div>

    )
}